import _ from 'lodash';

/* @ngInject */
export default function MonitoringActionsPanelService($q, $sails, $log, EquipmentInfoService) {
  const service = this;

  /**
   * Public Variables
   */
  service.equipmentModel = {};

  /**
   * Public Methods
   */
  service.getEquipmentFromIds = getEquipmentFromIds;
  service.powerCycleEquipment = powerCycleEquipment;
  service.deleteModel = deleteModel;

  function getEquipmentFromIds(equipmentIds) {
    return EquipmentInfoService.getEquipmentById(equipmentIds)
      .then((equipment) => {
        _.forEach(equipment, (eq) => {
          service.equipmentModel[eq.id] = eq;
        });
      })
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error);
      });
  }

  function powerCycleEquipment(rcuId) {
    return $sails.post(`/rcu/powerCycleEquipment/${rcuId}`, {})
      .catch((error) => {
        $log.log('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function deleteModel() {
    service.equipmentModel = {};
  }
}
